import { Badge, Card, Table } from "react-bootstrap";

import styled from "styled-components";
import PageTemplate from "../../templates/Pagetemplate";
import BreadCrumb from "../../molecules/BreadCrumb";
import { useQuery } from "@tanstack/react-query";
import {useParams} from "react-router";
import { Link } from "react-router-dom";
import axios from "axios";
import Loading from "../../organisms/Loading";


const TableWrap = styled.div`
    .badge {
        font-size: 14px;
        font-weight: 400;
    }
    th,
    td {
        padding: 15px;
    }
`;
export default function DetailUser(props) {
    const {id} = useParams();

    const {data, isLoading} = useQuery({
        queryKey: ['userDetail', id],
        queryFn: () => {
            return axios("/user/"+id, {
                method: "GET",
            }).then(result => {
                if (result.data.code != "0") {
                    throw Error;
                }

                return result.data
            });
        },
    });
    
    if (isLoading) {
        return <Loading/>
    }

    return (
        <>
            <PageTemplate.Top>
                <BreadCrumb arr={[<Link to={-1}>리포트 관리</Link> , "고객 정보"]} />
                <h1 className="page-title">고객 정보</h1>
            </PageTemplate.Top>
            {
                data && 
                <PageTemplate.Content>

                    <Card className="overflow-hidden">
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <Card.Title className="d-flex align-items-center gap-2 fs-3 mb-0">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z"/>
                                </svg>
                                기본 정보
                            </Card.Title>

                            <div className="small text-secondary">
                                <span className="border-end pe-2 me-2">업데이트 일시</span> {data.data.updateTime}
                            </div>
                        </Card.Header>
                        <TableWrap>
                            <Table>
                                <colgroup>
                                    <col style={{ width: "10%" }} />
                                    <col style={{ width: "35%" }} />
                                    <col style={{ width: "10%" }} />
                                    <col style={{ width: "35%" }} />
                                </colgroup>
                                <tbody className="border-top-0">
                                    <tr>
                                        <th className="bg-light">이름</th>
                                        <td>{data.data.name}</td>
                                        <th className="bg-light">성별</th>
                                        <td>{data.data.gender}</td>
                                    </tr>
                                    <tr>
                                        <th className="bg-light">생년월일</th>
                                        <td>{data.data.birth}</td>
                                        <th className="bg-light">연령 (만 나이)</th>
                                        <td>{data.data.age}</td>
                                    </tr>
                                    <tr>
                                        <th className="bg-light">이메일</th>
                                        <td>{data.data.email ? data.data.email : "-"}</td>
                                        <th className="bg-light">전화번호</th>
                                        <td>{data.data.phone ? data.data.phone : "-"}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </TableWrap>
                    </Card>

                    <Card className="mt-4 overflow-hidden">
                        <Card.Header>
                            <Card.Title className="d-flex align-items-center gap-2 fs-3">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5M3.854 2.146a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708L2 3.293l1.146-1.147a.5.5 0 0 1 .708 0m0 4a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708L2 7.293l1.146-1.147a.5.5 0 0 1 .708 0m0 4a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0"/>
                                </svg>
                                기본 설문
                            </Card.Title>
                        </Card.Header>
                        <TableWrap>
                            <Table>
                                <colgroup>
                                    <col style={{ width: "10%" }} />
                                    <col style={{ width: "35%" }} />
                                    <col style={{ width: "10%" }} />
                                    <col style={{ width: "35%" }} />
                                </colgroup>
                                <tbody className="border-top-0">
                                    <tr>
                                        <th className="bg-light">결혼 여부</th>
                                        <td>{data.data.maritalStatus ? data.data.maritalStatus : "-"}</td>
                                        <th className="bg-light">미용 치료 경험 유무</th>
                                        <td>{data.data.hasBeauty ? data.data.hasBeauty : "-"}</td>
                                    </tr>
                                    <tr>
                                        <th className="bg-light">어린 자녀 유무</th>
                                        <td>{data.data.hasBaby ? data.data.hasBaby : "-"}</td>
                                        <th className="bg-light">알러지 체질 여부</th>
                                        <td>{data.data.isIrritability ? data.data.isIrritability : "-"}</td>
                                    </tr>
                                    <tr>
                                        <th className="bg-light">개선 희망 문제</th>
                                        <td>
                                            <div className="d-flex gap-2 flex-wrap">
                                                {data.data.target.pore == 1 && <Badge bg="dark">모공</Badge>}
                                                {data.data.target.blackhead == 1 && <Badge bg="dark">블랙헤드</Badge>}
                                                {data.data.target.acne == 1 && <Badge bg="dark">여드름</Badge>}
                                                {data.data.target.sensitive == 1 && <Badge bg="dark">홍조</Badge>}
                                                {data.data.target.wrinkle == 1 && <Badge bg="dark">주름</Badge>}
                                                {data.data.target.speckle == 1 && <Badge bg="dark">색소스팟</Badge>}
                                                {data.data.target.black_rim_of_eye == 1 && <Badge bg="dark">다크서클</Badge>}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </TableWrap>
                    </Card>

                    <Card className="mt-4 overflow-hidden">
                        <Card.Header>
                            <Card.Title className="d-flex align-items-center gap-2 fs-3">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001m-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708z"/>
                                </svg>
                                메모
                            </Card.Title>
                        </Card.Header>
                        <Card.Body className="text-body">
                            {data.data.memo ? data.data.memo : "-"}
                        </Card.Body>
                    </Card>

                    <Card className="mt-4 overflow-hidden">
                        <Card.Header className="d-flex align-items-center justify-content-between">
                            <Card.Title className="d-flex align-items-center gap-2 fs-3 m-0">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022zm2.004.45a7 7 0 0 0-.985-.299l.219-.976q.576.129 1.126.342zm1.37.71a7 7 0 0 0-.439-.27l.493-.87a8 8 0 0 1 .979.654l-.615.789a7 7 0 0 0-.418-.302zm1.834 1.79a7 7 0 0 0-.653-.796l.724-.69q.406.429.747.91zm.744 1.352a7 7 0 0 0-.214-.468l.893-.45a8 8 0 0 1 .45 1.088l-.95.313a7 7 0 0 0-.179-.483m.53 2.507a7 7 0 0 0-.1-1.025l.985-.17q.1.58.116 1.17zm-.131 1.538q.05-.254.081-.51l.993.123a8 8 0 0 1-.23 1.155l-.964-.267q.069-.247.12-.501m-.952 2.379q.276-.436.486-.908l.914.405q-.24.54-.555 1.038zm-.964 1.205q.183-.183.35-.378l.758.653a8 8 0 0 1-.401.432z"/>
                                <path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0z"/>
                                <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5"/>
                                </svg>
                                측정 히스토리
                            </Card.Title>
                            <p className="m-0 small">
                                총 검사 횟수 <span className="fw-bold">{data.data.report.length}</span>회
                            </p>
                        </Card.Header>
                        <TableWrap>
                            <Table className="thead-light">
                                <colgroup>
                                    <col style={{ width: "5%" }} />
                                    <col style={{ width: "15%" }} />
                                    <col style={{ width: "10%" }} />
                                    <col style={{ width: "50%" }} />
                                    <col style={{ width: "20%" }} />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th className="text-center">회차</th>
                                        <th>리포트ID</th>
                                        <th>모델명</th>
                                        <th className="text-center">피부 결과</th>
                                        <th className="text-center">측정 일시</th>
                                    </tr>
                                </thead>
                                <tbody className="border-top-0">
                                    {
                                        data.data.report.reverse().map((el, idx) => {
                                            return (
                                            <tr key={idx}>
                                                <td className="text-center">{data.data.report.length - idx}</td>
                                                <td>{el.rid}</td>
                                                <td>{el.modelName}</td>
                                                <td>
                                                    <div className="d-flex flex-wrap" style={{ gap: "5px" }}>
                                                        <Badge bg="secondary">{el.badgeList.acne}</Badge>
                                                        <Badge bg="secondary">{el.badgeList.blackRimOfEye}</Badge>
                                                        <Badge bg="secondary">{el.badgeList.blackhead}</Badge>
                                                        <Badge bg="secondary">{el.badgeList.eyeBags}</Badge>
                                                        <Badge bg="secondary">{el.badgeList.eyeSagging}</Badge>
                                                        <Badge bg="secondary">{el.badgeList.pore}</Badge>
                                                        <Badge bg="secondary">{el.badgeList.sensitive}</Badge>
                                                        <Badge bg="secondary">{el.badgeList.skinGlow}</Badge>
                                                        <Badge bg="secondary">{el.badgeList.speckle}</Badge>
                                                        <Badge bg="secondary">{el.badgeList.wrinkle}</Badge>
                                                    </div>
                                                </td>
                                                <td className="text-center">{el.reportTime}</td>
                                            </tr>
                                            );
                                        })
                                    }
                                </tbody>
                            </Table>
                        </TableWrap>
                    </Card>
                </PageTemplate.Content>
            }
        </>
    );
}
